import { render, staticRenderFns } from "./Badge.vue?vue&type=template&id=0a160a67&functional=true"
import script from "./Badge.vue?vue&type=script&lang=js"
export * from "./Badge.vue?vue&type=script&lang=js"
import style0 from "./Badge.vue?vue&type=style&index=0&id=0a160a67&lang=scss&module=true"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style0.locals || style0)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./Badge.vue?vue&type=style&index=0&id=0a160a67&lang=scss&module=true"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("./Badge.vue?vue&type=style&index=0&id=0a160a67&lang=scss&module=true")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("/drone/src/node_modules/@vue/cli-service/node_modules/vue-hot-reload-api/dist/index.js").rerender("0a160a67")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/@vue/cli-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a160a67')) {
      api.createRecord('0a160a67', component.options)
    } else {
      api.rerender('0a160a67', component.options)
    }
    module.hot.accept("./Badge.vue?vue&type=template&id=0a160a67&functional=true", function () {
      api.rerender('0a160a67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/others/Badge.vue"
export default component.exports